"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RunIterator = void 0;
var fixed_1 = require("@devexpress/utils/lib/intervals/fixed");
var RunIterator = (function () {
    function RunIterator(runs, chunks, sections, indexForChunks, indexForSections) {
        this.currentRun = null;
        this.currentChunk = null;
        this.currentSection = null;
        this.runs = [];
        this.chunks = [];
        this.sections = [];
        this.currentRunIndex = 0;
        this.currentChunkIndex = 0;
        this.currentSectionIndex = 0;
        this.indexForChunks = [];
        this.indexForSections = [];
        this.runs = runs;
        this.chunks = chunks;
        this.sections = sections;
        this.indexForChunks = indexForChunks;
        this.indexForSections = indexForSections;
    }
    RunIterator.prototype.moveNext = function () {
        this.currentRun = this.runs[this.currentRunIndex];
        if (this.currentRun) {
            this.currentChunk = this.chunks[this.currentChunkIndex];
            this.currentSection = this.sections[this.currentSectionIndex];
            if (this.currentRunIndex == this.indexForChunks[this.currentChunkIndex])
                this.currentChunkIndex++;
            if (this.currentRunIndex == this.indexForSections[this.currentSectionIndex])
                this.currentSectionIndex++;
            this.currentRunIndex++;
            return true;
        }
        else {
            this.currentChunk = undefined;
            this.currentSection = undefined;
            return false;
        }
    };
    RunIterator.prototype.currentInterval = function () {
        if (this.currentRun)
            return new fixed_1.FixedInterval(this.currentChunk.startLogPosition.value + this.currentRun.startOffset, this.currentRun.getLength());
        else
            return new fixed_1.FixedInterval(this.chunks[0].startLogPosition.value + this.runs[0].startOffset, this.runs[0].getLength());
    };
    RunIterator.prototype.getFirstRun = function () {
        return this.runs[0];
    };
    RunIterator.prototype.getLastRun = function () {
        return this.runs[this.runs.length - 1];
    };
    RunIterator.prototype.getRunsCount = function () {
        return this.runs.length;
    };
    RunIterator.prototype.reset = function () {
        this.currentRunIndex = 0;
        this.currentChunkIndex = 0;
        this.currentSectionIndex = 0;
    };
    return RunIterator;
}());
exports.RunIterator = RunIterator;
